"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64EncodeForBasicAuth = void 0;
function base64EncodeForBasicAuth(username, password) {
    return Buffer.from(username + ":" + password).toString('base64');
}
exports.base64EncodeForBasicAuth = base64EncodeForBasicAuth;
//# sourceMappingURL=utils.js.map